import { type api, isDefined } from 'common';

import { EntityLink } from '../../../../components/links/EntityLink';

interface FlowTableProps {
  flowRun: api.FlowRun.FlowRunSummary;
}

export function EntityCellContent(props: FlowTableProps) {
  const { flowRun } = props;

  const { entityType, entityId } = flowRun;

  if (isDefined(entityType) && isDefined(entityId)) {
    return <EntityLink entityId={entityId} entityType={entityType} />;
  }
  return <span>None</span>;
}
